import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  Tag,
  Descriptions,
  Button,
  Tabs,
  Avatar,
  Modal,
  Spin,
  Input,
  Typography,
  Table,
} from "antd";
import {
  UserOutlined,
  FileTextOutlined,
  ArrowRightOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { useParams, Link } from "react-router-dom";
import useFetchWithToken from "../../services/api";

const { TabPane } = Tabs;
const { Title } = Typography;
const { Search } = Input;

function PassengersDetail() {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const { id } = useParams();
  const { data: passengerData, loading: passengerLoading } = useFetchWithToken(
    `passengers/${id}`
  );
  const { data: tripData, loading: tripsLoading } = useFetchWithToken(
    `trips/passenger/${id}`
  );

  const trips = Array.isArray(tripData)
    ? tripData.map((item) => ({
        ...item,
        passenger: item.passenger || { firstName: "N/A", lastName: "" },
        driver: item.driver || {},
      }))
    : [];

  const passenger = passengerData?.passenger;

  const filteredTrips = trips.filter((trip) => {
    const lowerCaseQuery = searchQuery.toLowerCase();
    return (
      trip.status.toLowerCase().includes(lowerCaseQuery) ||
      trip.driver.firstName.toLowerCase().includes(lowerCaseQuery) ||
      trip.driver.lastName.toLowerCase().includes(lowerCaseQuery)
    );
  });

  const handlePreview = (src) => {
    setPreviewImage(src);
    setPreviewVisible(true);
  };

  const renderImage = (src, alt) => (
    src ? (
      <img
        src={`http://93.127.203.113:5005${src}`}
        alt={alt}
        style={{
          width: "100%",
          height: "300px",
          objectFit: "cover",
          cursor: "pointer",
          borderRadius: "10px",
          boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        }}
        onClick={() => handlePreview(`http://93.127.203.113:5005${src}`)}
      />
    ) : (
      <Avatar
        shape="square"
        icon={<UserOutlined />}
        style={{
          width: "100%",
          height: "300px",
          borderRadius: "10px",
          backgroundColor: "#f0f2f5",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      />
    )
  );

  const tripsColumns = [
    {
      title: <span style={{ fontWeight: "bold" }}>Trip ID</span>,
      dataIndex: "id",
      key: "id",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Driver</span>,
      key: "driver",
      render: (_, record) =>
        record.driver
          ? `${record.driver.firstName} ${record.driver.lastName}`
          : "N/A",
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Price</span>,
      dataIndex: "price",
      key: "price",
      render: (text) => `ETB ${text}`,
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Status</span>,
      dataIndex: "status",
      key: "status",
      render: (status) => (
        <Tag
          color={
            status === "Active"
              ? "#0c8c49"
              : status === "Ended"
              ? "red"
              : "orange"
          }
        >
          {status.toUpperCase()}
        </Tag>
      ),
    },
    {
      title: <span style={{ fontWeight: "bold" }}>Actions</span>,
      key: "actions",
      render: (_, record) => (
        <Link to={`/tripDetails/${record.id}`}>
          <Button type="link" style={{ color: "#0c8c49" }}>
            Details
          </Button>
        </Link>
      ),
    },
  ];

  if (passengerLoading || tripsLoading) {
    return (
      <div style={{ textAlign: "center", marginTop: "50px" }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div style={{ padding: "20px" }}>
      <Card
        style={{
          marginBottom: "20px",
          borderRadius: "10px",
          boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
          borderTop: "5px solid #0c8c49",
        }}
      >
        <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
          Customer Details
        </Title>
        <Tabs defaultActiveKey="1" type="card" tabBarStyle={{ color: "#aa0077" }}>
          <TabPane tab={<span><ArrowRightOutlined /> Overview</span>} key="1">
            <Row gutter={[16, 16]}>
              <Col span={12}>
                <Descriptions bordered column={1}>
                  <Descriptions.Item label="First Name">
                    {passenger?.firstName || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Last Name">
                    {passenger?.lastName || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Phone">
                    {passenger?.phoneNumber || "N/A"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Status">
                    <Tag
                      color={
                        passenger?.status === "Active"
                          ? "#0c8c49"
                          : passenger?.status === "Inactive"
                          ? "red"
                          : "orange"
                      }
                    >
                      {passenger?.status?.toUpperCase() || "N/A"}
                    </Tag>
                  </Descriptions.Item>
                  <Descriptions.Item label="Rating">
                    {/* <Rate disabled value={5} /> */}
                  </Descriptions.Item>
                </Descriptions>
              </Col>
              <Col span={12}>
                <Card
                  title="Passenger Image"
                  style={{
                    borderRadius: "10px",
                    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  {renderImage(passenger?.passengerImage, "Passenger Image")}
                </Card>
              </Col>
            </Row>
          </TabPane>
          {/* <TabPane tab={<span><FileTextOutlined /> Trips</span>} key="2">
            <Card
              style={{
                borderRadius: "10px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              }}
            >
              <Search
                placeholder="Search trips"
                allowClear
                enterButton={<SearchOutlined />}
                onChange={(e) => setSearchQuery(e.target.value)}
                style={{ marginBottom: "16px", width: "50%" }}
              />
              <Table
                columns={tripsColumns}
                dataSource={filteredTrips}
                rowKey="id"
                bordered
                pagination={{ pageSize: 5 }}
              />
            </Card>
          </TabPane> */}
        </Tabs>
      </Card>

      <Modal
        visible={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        centered
      >
        <img alt="Preview" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </div>
  );
}

export default PassengersDetail;
